<template>
  <div>
    <h2 v-if="checkboxes.length" class="cross-sell--title">
      {{ label }}
    </h2>
    <div class="cross-sell-container">
      <div
        v-if="checkboxes.length > currentPerView"
        class="cross-sell__prev-btn desktop-only"
        @click="scrollLeft"
      >
        <arrowLeft class="cross-sell__arrow" />
      </div>
      <ul
        :class="[
          'cross-sell',
          { 'cross-sell--cart': cartPage, 'has-checkbox': productPage },
        ]"
      >
        <new-cross-sell-item
          v-for="checkbox in checkboxes"
          :key="checkbox.checkbox_id"
          :checkbox="checkbox"
          :order-number="orderNumber"
          :mode="mode"
          @updateCart="updateCart"
          @crossSellCheckboxChecked="$emit('crossSellCheckboxChecked', $event)"
          @crossSellCheckboxUnchecked="
            $emit('crossSellCheckboxUnchecked', $event)
          "
        />
      </ul>
      <div
        v-if="checkboxes.length > currentPerView"
        class="cross-sell__next-btn desktop-only"
        @click="scrollRight"
      >
        <arrowRight class="cross-sell__arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import NewCrossSellItem from '~/components/cross-sell/cross-sell-item/NewCrossSellItem'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'
import itemsPerBreakpoint from '~/mixins/itemsPerBreakpoint'

export default {
  name: 'CrossSell',
  components: {
    NewCrossSellItem,
    ArrowLeft,
    ArrowRight,
  },
  mixins: [itemsPerBreakpoint],
  props: {
    label: {
      type: String,
      default: '',
    },
    productSku: {
      type: String,
      default: '',
    },
    orderNumber: {
      type: [Number, String],
      default: '',
    },
    caseDevice: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'product',
    },
  },
  async fetch() {
    try {
      this.checkboxes = []

      const storeInfo = this.$store.getters.storeInfo
      const params = {
        ...storeInfo,
        case_device: this.caseDevice,
      }

      params.optimized = true

      const endpoint = this.productPage
        ? `bundle/product/${this.productSku}`
        : 'bundle/cart'

      const { checkboxes } = await this.$axios.$get(endpoint, {
        params,
      })

      this.checkboxes = checkboxes
      this.$emit('showcheckboxes', this.checkboxesLength > 0)
    } catch (err) {
      this.$displayTopMessage(this.$t('action_error'), {
        type: 'error',
      })
    }
  },
  data() {
    return {
      checkboxes: [],
    }
  },
  computed: {
    cartPage() {
      return this.mode === 'cart'
    },
    productPage() {
      return this.mode === 'product'
    },
    checkboxesLength() {
      return this.checkboxes.length
    },
  },
  watch: {
    caseDevice(newVal) {
      this.$fetch()
    },
  },
  methods: {
    updateCart(event) {
      this.checkboxes.forEach((checkbox, index) => {
        if (event.id === checkbox.checkbox_id) this.checkboxes.splice(index, 1)
      })
      this.$emit('updateCart', event.cart)
    },
    scrollLeft() {
      const container = this.$el.querySelector('.cross-sell')
      container.scrollBy({ left: -500, behavior: 'smooth' })
    },
    scrollRight() {
      const container = this.$el.querySelector('.cross-sell')
      container.scrollBy({ left: 500, behavior: 'smooth' })
    },
  },
  fetchOnServer: false,
}
</script>

<style lang="scss" scoped>
.cross-sell-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.cross-sell__prev-btn,
.cross-sell__next-btn {
  color: white;
  background-color: #fcf6f3;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  cursor: pointer;
  border: 0;
  width: 48px;
  height: 48px;
  line-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  .cross-sell__arrow {
    width: 18px;
    fill: $v4_color_primary;
    transition: all 0.2s ease-in-out;
  }

  &.disabled {
    display: none;
  }

  &:hover {
    background-color: lighten(#fcf6f3, 1%);
  }
}

.cross-sell__prev-btn {
  left: -30px;
}

.cross-sell__next-btn {
  right: -30px;
}

.cross-sell--title {
  font-size: 20px;
  text-align: flex-start;
  margin: 4px;
}

.cross-sell {
  display: flex;
  overflow-x: auto;
  padding: 0;
  scroll-behavior: smooth;
  gap: 21.48px;

  &::-webkit-scrollbar {
    display: none;

    .new-cross-sell-item {
      list-style: none;
      display: flex;
      flex-direction: column;
    }
  }
}

@media (max-width: $screen_large) {
  .cross-sell--title {
    font-size: 15px;
  }

  .cross-sell__prev-btn,
  .cross-sell__next-btn {
    width: 40px;
    height: 40px;

    .cross-sell__arrow {
      width: 14px;
    }
  }

  .cross-sell__prev-btn {
    left: -10px;
  }

  .cross-sell__next-btn {
    right: -10px;
  }
}
</style>
